import { useQuery } from "@tanstack/react-query";
import { TanstackQueryKey } from "apps/commons/tanstackQueryKey";
import { postPublishSuccessApi } from "libs/api";
import { useParams } from "router";
import { useSetPropertyViewModel } from "./propertyViewModelAtom";

export const useGetPropertyViewModel = () => {
    const setViewModel = useSetPropertyViewModel();
    const { lang, propertyId } = useParams("/:lang/list-my-property/onboard/:propertyId/complete");

    useQuery({
        queryKey: [TanstackQueryKey.GetPropertyViewModel, lang, propertyId],
        queryFn: () => postPublishSuccessApi.getPropertyViewModel(lang, Number(propertyId)),
        onSuccess: (response) => setViewModel(response.data),
    });
};
